import { Container, Exchanges } from '@/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ExchangesPage.module.scss';

const ExchangesPage: FC = () => {
  const { t } = useTranslation('exchanges');

  return (
    <Container title={t('title')} className={styles.container}>
      <Exchanges tableHeight="59vh" />
    </Container>
  );
};

export default ExchangesPage;
